import React from 'react';
import { Outlet } from 'react-router-dom';

const DefaultGrid: React.FC = () => {
  return (
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 w-full flex flex-col mt-10">
      <Outlet />
    </div>
  );
};

export default DefaultGrid;
